"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShipInternalColorTint = exports.getShipHullColorTint = exports.updateShipInternalColor = exports.updateShipHullColor = exports.update = exports.get = exports.create = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
var localStorer_sidecar_1 = require("../lib/localStorer-sidecar");
var pubSub_sidecar_1 = require("./pubSub-sidecar");
var settings = {
    devMode: false,
    freeBuildMode: false,
    multiplayerName: 'NewPlayer',
    muteSound: false,
    muteMusic: false,
    muteAmbient: false,
    soundVolume: 8,
    musicVolume: 5,
    ambientVolume: 5,
    skipStart: false,
    disableShaderTransitions: false,
    filename: 'test',
    testRigNum: -1,
    shipHullColor: { h: 100, s: 50, l: 50 },
    shipInternalColor: { h: 100, s: 10, l: 90 },
    physicsShowDebug: false,
};
var _localStorageKey = '';
var _version = 0;
function create(localStorageKey, version) {
    _localStorageKey = localStorageKey;
    _version = version;
    load();
}
exports.create = create;
function get() {
    return settings;
}
exports.get = get;
function update(updates, doSave) {
    if (doSave === void 0) { doSave = true; }
    // console.log('update settings', updates, settings)
    settings = Object.assign({}, settings, updates);
    if (doSave) {
        save();
    }
    // console.log('update settings', updates, settings)
    pubSub_sidecar_1.pubSub.emit('settings:update');
}
exports.update = update;
function updateShipHullColor(updates, doSave) {
    if (doSave === void 0) { doSave = true; }
    var newColor = Object.assign({}, settings.shipHullColor, updates);
    update({ shipHullColor: newColor }, doSave);
}
exports.updateShipHullColor = updateShipHullColor;
function updateShipInternalColor(updates, doSave) {
    if (doSave === void 0) { doSave = true; }
    var newColor = Object.assign({}, settings.shipInternalColor, updates);
    update({ shipInternalColor: newColor }, doSave);
}
exports.updateShipInternalColor = updateShipInternalColor;
function load() {
    var data = localStorer_sidecar_1.localStorer.load(_localStorageKey, _version);
    if (data) {
        update(data, false);
    }
    console.log('loaded settings', data);
}
function save() {
    localStorer_sidecar_1.localStorer.save(_localStorageKey, _version, get());
}
function getShipHullColorTint() {
    var c = chroma_js_1.default(settings.shipHullColor.h, settings.shipHullColor.s / 100, settings.shipHullColor.l / 100, 'hsl');
    return c.num();
}
exports.getShipHullColorTint = getShipHullColorTint;
function getShipInternalColorTint() {
    var c = chroma_js_1.default(settings.shipInternalColor.h, settings.shipInternalColor.s / 100, settings.shipInternalColor.l / 100, 'hsl');
    return c.num();
}
exports.getShipInternalColorTint = getShipInternalColorTint;
// export function toggl() {
//   update({ muteMusic: !get().muteMusic })
// }
